import { Link } from 'react-router-dom';
import React from 'react';
import './Error404.scss';


const Error404 = props => {
  return (
    <div>
      <div>
        <center className='container-name'>
          <h2 className='md-display-4'>ERROR</h2>
          <h3 className='md-display-4'>404</h3>
          <Link to="/">Go back to safety</Link>
        </center>
      </div>
    </div>
  );
};


export default Error404;
